export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';

export const setSearchQuery = payload => ({ type: SET_SEARCH_QUERY, payload });

export const CLEAR_SEARCH_QUERY = 'CLEAR_SEARCH_QUERY';

export const clearSearchQuery = payload => ({ type: CLEAR_SEARCH_QUERY, payload });
